import { IAction } from '@Root/types'

import {
  IFetchTranslationLanguagesPayload,
  IFetchTranslationLanguagesSuccessResponseBody,
} from '@SiteModules/ProjectVersionSettings/types'

export const ProjectVersionSettingsTtsActionTypes = {
  FETCH_PROJECT_VERSION_SETTINGS_TTS: '@@projectVersionSettingsTts/FETCH_PROJECT_VERSION_SETTINGS_TTS',
  FETCH_PROJECT_VERSION_SETTINGS_TTS_SUCCESS: '@@projectVersionSettingsTts/FETCH_PROJECT_VERSION_SETTINGS_TTS_SUCCESS',
  FETCH_PROJECT_VERSION_SETTINGS_TTS_FAILURE: '@@projectVersionSettingsTts/FETCH_PROJECT_VERSION_SETTINGS_TTS_FAILURE',
  SETUP_TTS: '@@projectVersionSettingsTts/SETUP_TTS',
  SETUP_TTS_SUCCESS: '@@projectVersionSettingsTts/SETUP_TTS_SUCCESS',
  SETUP_TTS_FAILURE: '@@projectVersionSettingsTts/SETUP_TTS_FAILURE',
  RESET_PROJECT_VERSION_SETTINGS_TTS: '@@projectVersionSettingsTts/RESET_PROJECT_VERSION_SETTINGS_TTS',
  FETCH_TRANSLATION_LANGUAGES_TTS: '@@projectVersionSettingsTts/FETCH_TRANSLATION_LANGUAGES_TTS',
  FETCH_TRANSLATION_LANGUAGES_TTS_SUCCESS: '@@projectVersionSettingsTts/FETCH_TRANSLATION_LANGUAGES_TTS_SUCCESS',
  FETCH_TRANSLATION_LANGUAGES_TTS_FAILURE: '@@projectVersionSettingsTts/FETCH_TRANSLATION_LANGUAGES_TTS_FAILURE',
  RESET_TRANSLATION_LANGUAGES_TTS: '@@projectVersionSettingsTts/RESET_TRANSLATION_LANGUAGES_TTS'
}

export interface IProjectVersionSettingsTtsState {
  readonly settings: IProjectVersionSettingsTtsAttributes
  readonly availableLanguages: IAvailableTtsLanguagesAttributes
  readonly lastUsedSettings: ILastUsedSettingsTtsAttributes
  readonly hasLoadedSuccessfully: boolean
  readonly fetchingTranslationLanguages: boolean
}

export interface IProjectVersionSettingsTtsAttributes {
  readonly language: string
  readonly subtitleLanguages: string[]
  readonly projectTermbaseName?: string
}

export interface IAvailableTtsLanguagesAttributes {
  readonly dubbingLanguages: string[]
  readonly dubbingLanguagesTranslation: string[]
}

export interface ILastUsedSettingsTtsAttributes {
  readonly lastUsedTtsTranscriptInformation?: ITranscriptTtsInformation
  readonly lastUsedTtsTranslationInformation?: ITranslationTtsInformation
  readonly lastUsedTermbaseName?: string
}

export interface ITranscriptTtsInformation {
  readonly language?: string
  readonly subtitleLanguages?: string[]
}

export interface ITranslationTtsInformation {
  readonly lastUsedFormality?: string
}

export interface IFetchProjectVersionSettingsTtsPayload {
  readonly workspaceId: number
  readonly projectVersionIds?: string[]
}

export interface IFetchProjectVersionSettingsTtsSuccessResponseBody {
  readonly projectVersionSettings: IProjectVersionSettingsTtsData | undefined
  readonly availableLanguages: IAvailableTtsLanguagesData
  readonly lastUsedSettings: ILastUsedSettingsTtsData
}

export interface IProjectVersionSettingsTtsData {
  readonly id: string
  readonly type: 'projectVersionSettingsTts'
  readonly attributes: IProjectVersionSettingsTtsAttributes
}

export interface IAvailableTtsLanguagesData {
  readonly attributes: IAvailableTtsLanguagesAttributes
}

export interface ILastUsedSettingsTtsData {
  readonly id: string
  readonly type: 'lastUsedSettingsTts'
  readonly attributes: ILastUsedSettingsTtsAttributes
}

export interface ISetupTtsPayload {
  readonly workspaceId: number
  readonly projectVersionLanguage: string
  readonly includesTranscript: boolean
  readonly scriptText?: string
  readonly termbaseName?: string
  readonly translationLanguages?: string[]
  readonly formality?: string
  readonly projectVersionId?: string
}

export interface ISetupTtsSuccessResponseBody {
  readonly editorUrl: string
}

export interface IFetchTranslationLanguagesTtsPayload extends IFetchTranslationLanguagesPayload {
  readonly isForTts?: boolean
}

export type IFetchTranslationLanguagesTtsSuccessResponseBody = IFetchTranslationLanguagesSuccessResponseBody

export type TProjectVersionSettingsTtsActionTypes =
  IAction<IFetchProjectVersionSettingsTtsSuccessResponseBody> |
  IAction<IFetchTranslationLanguagesTtsSuccessResponseBody>
